import { global } from '../utils';
import { MapMeasurementSystemToTemperatureUnit, MeasurementSystem, TemperatureUnit, } from '../types';
import { MapTemperatureUnitApiValuesToDisplayUnit } from '../types/Global';
export function toCelsius(fahrenheit) {
    return ((fahrenheit - 32) * 5) / 9;
}
export function toFahrenheit(celsius) {
    return (celsius * 9) / 5 + 32;
}
export default function convertTemp(value, from, decimals = 2) {
    let valCopy = value;
    if (isNaN(Number(valCopy))) {
        return global.NOT_AVAILABLE;
    }
    if (typeof valCopy !== 'number')
        valCopy = Number(valCopy);
    if (from === 'c') {
        return +toFahrenheit(valCopy).toFixed(decimals);
    }
    return +toCelsius(valCopy).toFixed(decimals);
}
export function convertHysteresis(value, from, decimals = 2) {
    let valCopy = value;
    /* eslint-disable */
    if (isNaN(Number(valCopy))) {
        return 0;
    }
    /* eslint-enable */
    if (typeof valCopy !== 'number')
        valCopy = Number(valCopy);
    if (from === 'c') {
        return (parseInput(toFahrenheit, value, 3) - parseInput(toFahrenheit, 0, 3)).toFixed(decimals);
    }
    return (parseInput(toCelsius, value, 3) - parseInput(toCelsius, 0, 3)).toFixed(decimals);
}
// IMPORTANT: This function ONLY takes C temperature values.
export const createTemperatureValue = (valueInCelsius, user, numDecimals = 1) => {
    var _a, _b, _c, _d;
    const { measurementSystem, temperature } = user;
    switch (temperature) {
        case 'CELSIUS':
            return +((_a = valueInCelsius) === null || _a === void 0 ? void 0 : _a.toFixed(numDecimals));
        case 'FAHRENHEIT':
            return +((_b = toFahrenheit(valueInCelsius)) === null || _b === void 0 ? void 0 : _b.toFixed(numDecimals));
        default:
            return measurementSystem === MeasurementSystem.METRIC
                ? +((_c = valueInCelsius) === null || _c === void 0 ? void 0 : _c.toFixed(numDecimals))
                : +((_d = toFahrenheit(valueInCelsius)) === null || _d === void 0 ? void 0 : _d.toFixed(numDecimals));
    }
};
// IMPORTANT: This function ONLY takes C temperature values.
export const createTemperatureString = (valueInCelsius, user, numDecimals = 1) => {
    const convertedValue = createTemperatureValue(valueInCelsius, user, numDecimals);
    return formatValueAsTemp(convertedValue, user);
};
export const getUserPreferenceTemperatureUnit = (currentUser) => {
    const { measurementSystem, temperature } = currentUser;
    const unit = temperature
        ? MapTemperatureUnitApiValuesToDisplayUnit[temperature]
        : MapMeasurementSystemToTemperatureUnit[measurementSystem];
    return unit;
};
export const formatValueAsTemp = (value, user) => {
    const { measurementSystem, temperature } = user;
    switch (temperature) {
        case 'CELSIUS':
            return `${value} ${TemperatureUnit.C}`;
        case 'FAHRENHEIT':
            return `${value} ${TemperatureUnit.F}`;
        default:
            return measurementSystem === MeasurementSystem.METRIC
                ? `${value} ${TemperatureUnit.C}`
                : `${value} ${TemperatureUnit.F}`;
    }
};
export function parseInput(fn, value, decimalPlaces) {
    if (value === '' || value === '-') {
        return value;
    }
    if (isNaN(value)) {
        return '';
    }
    return parseFloat(fn(parseFloat(value)).toFixed(decimalPlaces));
}
export function fixIfDecimal(num) {
    if (typeof num === 'string' || Number.isInteger(num)) {
        return num;
    }
    else {
        return num.toFixed(1);
    }
}
export function parseValueForDisplay(temperatureUnit, threshold) {
    if (threshold === null || threshold === undefined)
        return '';
    if (temperatureUnit === TemperatureUnit.C) {
        if (threshold === undefined) {
            return '';
        }
        else {
            return fixIfDecimal(threshold);
        }
    }
    else {
        return parseInput(toFahrenheit, threshold, 1);
    }
}
export function parseHysteresisValueForDisplay(currentUser, value) {
    if (value === null || value === undefined)
        return '';
    const temperatureUnit = getUserPreferenceTemperatureUnit(currentUser);
    if (temperatureUnit === TemperatureUnit.C) {
        if (value === undefined) {
            return '';
        }
        else {
            return fixIfDecimal(value);
        }
    }
    else {
        return fixIfDecimal(parseInput(toFahrenheit, value, 1) - parseInput(toFahrenheit, 0, 1));
    }
}
export const getTempDifferenceByUnit = (difference, unit) => {
    return unit === TemperatureUnit.C
        ? getTempDifferenceInFahrenheit(difference)
        : getTempDifferenceInCelsius(difference);
};
export const getTempDifferenceInCelsius = (difference) => {
    return difference / 1.8;
};
export const getTempDifferenceInFahrenheit = (difference) => {
    return difference * 1.8;
};
export function celsiusStdDevToFahrenheit(std) {
    // http://www.gmathacks.com/quant-topics/standard-deviation-on-the-gmat.html
    // https://psychstat3.missouristate.edu/Documents/IntroBook3/sbk13.htm
    // Only the multiplication part of the C => F formula is relevant for std dev
    return (std * 9.0) / 5.0;
}
